import { useEffect, useRef, type ReactNode } from "react";

interface DataTableProps {
  dense?: boolean;
  stickyFirstColumn?: boolean;
  className?: string;
  children: ReactNode;
}

// Wraps a <table> in a scroll container with the same scroll-shadow cues as
// the legacy DataTable.astro. Also auto-applies scope="col" / scope="row" to
// inner <th> elements for accessibility — the legacy inline script did this.
export function DataTable({ dense = false, stickyFirstColumn = false, className, children }: DataTableProps) {
  const wrap = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const table = wrap.current?.querySelector("table");
    if (!table) return;
    table.querySelectorAll("thead th:not([scope])").forEach((th) => th.setAttribute("scope", "col"));
    table.querySelectorAll("tbody th:not([scope])").forEach((th) => th.setAttribute("scope", "row"));
  });
  const cls = [
    "table-responsive",
    dense && "table-responsive--dense",
    stickyFirstColumn && "table-responsive--sticky-first",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div ref={wrap} className={cls}>
      {children}
    </div>
  );
}
